<template>
  <NuxtPwaAssets />
  <TopBar />
  <slot />
  <NuxtLoadingIndicator color="#27A5ED" />
  <Footer />
</template>

<script lang="ts" setup>
import { useAuthStore } from "~/store/auth";

const authStore = useAuthStore();


provide('isDutch', (() => {
  const route = useRoute();
  return route.matched.some(({path}) => path.startsWith('/nl'));
})())


onMounted(() => {
  authStore.loadUserFromStorage();
});

const runtimeConfig = useRuntimeConfig()
useSeoMeta({
  appleMobileWebAppTitle: "Promo Rewards",
  MobileWebAppCapable: "yes",
  themeColor: "#2A2A38",
  twitterCard: "summary_large_image",
  twitterSite: "@RewardsFlights",
  twitterCreator: "@RewardsFlights",
  twitterAppNameIphone: 'Reminder for Flying Blue',
  twitterAppIdIphone: '1672941903',
  twitterAppNameGoogleplay: 'Reminder for Flying Blue',
  twitterAppIdGoogleplay: 'flights.rewards.twa',
  ogSiteName: "Reminder for Flying Blue",
  ogType: "website",
  fbAppId: "3053348131634626",
  fbPages: "124706447395149",
});

useHead({
  htmlAttrs: {
    'data-bs-theme': 'dark',
  },
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: '/favicon.png'
    },
    {
      rel: "sitemap",
      type: "application/xml",
      href: "https://backend.rewards.flights/sitemap.xml",
    },
    {
      rel: "alternate",
      type: "application/atom+xml",
      title: "Promo Rewards",
      href: "https://feeds.feedburner.com/rewardsflights"
    },
    {
      rel: "alternate",
      type: "application/rss+xml",
      title: "Reminder for Flying Blue blog",
      href: "https://backend.rewards.flights/feed/blogs"
    },
  ]
})
</script>
